$('.hpe-configuration-tab').click(function () {
  const activeClass = 'hpe-configuration-tab--active';
  const activeTabClass = 'hpe-configuration-section--active';
  const activeTab = $(this).attr('data-tab');

  $(this)
    .parents('.hpe-configuration-carousel')
    .find('.hpe-configuration-tab')
    .removeClass(activeClass);

  $(this).addClass(activeClass);

  $('.hpe-configuration-section').removeClass(activeTabClass);
  $(`.hpe-configuration-section[data-config-tab="${activeTab}"]`).addClass(activeTabClass);
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/tab-configuration.js